import { FiX } from "react-icons/fi";

const inputClass =
  "w-full px-3.5 py-2.5 text-sm text-gray-800 bg-gray-50 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-indigo-300 focus:border-indigo-400 focus:bg-white placeholder-gray-400 transition-all";

const Field = ({ label, optional, children }) => (
  <div>
    <label className="block text-xs font-semibold text-gray-600 mb-1.5 uppercase tracking-wide">
      {label}{" "}
      {optional && <span className="normal-case font-normal text-gray-400">(Optional)</span>}
    </label>
    {children}
  </div>
);

const GuardianModal = ({
  modal,
  close,
  search,
  setSearch,
  searchLoading,
  results,
  saving,
  onLink,
  onOpenCreate,
  newParent,
  setNewParent,
  onCreate,
}) => {
  if (!modal) return null;
  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-gray-900/40"
      onMouseDown={close}
    >
      <div
        className="w-full max-w-lg bg-white rounded-2xl shadow-xl p-5"
        onMouseDown={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-4 mb-5">
          <div>
            <h2 className="text-lg font-semibold text-gray-900">
              {modal.mode === "link" ? "Link an existing parent" : "Create a new parent"}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              This updates the student’s {modal.slot === 0 ? "primary" : "secondary"} parent slot.
            </p>
          </div>
          <button type="button" onClick={close} className="p-2 text-gray-400 hover:text-gray-700">
            <FiX />
          </button>
        </div>
        {modal.mode === "link" ? (
          <>
            <input
              autoFocus
              value={search}
              onChange={(event) => setSearch(event.target.value)}
              placeholder="Search by name, email, or phone"
              className={inputClass}
            />
            <div className="mt-3 max-h-64 overflow-y-auto divide-y divide-gray-100 border border-gray-100 rounded-xl">
              {searchLoading ? (
                <p className="p-4 text-sm text-gray-500">Searching parent accounts...</p>
              ) : results.length === 0 ? (
                <p className="p-4 text-sm text-gray-500">No matching parent accounts found.</p>
              ) : (
                results.map((parent) => (
                  <button
                    type="button"
                    key={parent._id}
                    disabled={saving}
                    onClick={() => onLink(parent)}
                    className="w-full text-left p-3 hover:bg-indigo-50 disabled:opacity-50"
                  >
                    <p className="text-sm font-medium text-gray-800">
                      {parent.firstname} {parent.lastname}
                    </p>
                    <p className="text-xs text-gray-500">
                      {parent.email || "No email"}{" "}
                      {parent.mobile_number ? `• ${parent.mobile_number}` : ""}
                    </p>
                  </button>
                ))
              )}
            </div>
            <button
              type="button"
              onClick={() => onOpenCreate(modal.slot)}
              className="mt-4 text-sm text-indigo-600 hover:text-indigo-800"
            >
              Can’t find them? Create a new parent account
            </button>
          </>
        ) : (
          <form onSubmit={onCreate} className="space-y-3">
            <Field label="First Name">
              <input
                required
                value={newParent.firstname}
                onChange={(event) => setNewParent({ ...newParent, firstname: event.target.value })}
                className={inputClass}
              />
            </Field>
            <Field label="Last Name">
              <input
                required
                value={newParent.lastname}
                onChange={(event) => setNewParent({ ...newParent, lastname: event.target.value })}
                className={inputClass}
              />
            </Field>
            <Field label="Phone Number">
              <input
                required
                value={newParent.phone}
                onChange={(event) => setNewParent({ ...newParent, phone: event.target.value })}
                placeholder="e.g. 08012345678"
                className={inputClass}
              />
            </Field>
            <Field label="Email Address" optional>
              <input
                type="email"
                value={newParent.email}
                onChange={(event) => setNewParent({ ...newParent, email: event.target.value })}
                className={inputClass}
              />
            </Field>
            <div className="flex justify-end gap-2 pt-3">
              <button type="button" onClick={close} className="px-4 py-2 text-sm text-gray-600">
                Cancel
              </button>
              <button
                disabled={saving}
                className="px-4 py-2 text-sm text-white bg-indigo-600 rounded-xl disabled:opacity-50"
              >
                {saving ? "Creating..." : "Create and link"}
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default GuardianModal;
